<style scoped>
.card {
  position: relative !important;
}

.card-image {
  padding: 24px 0 0 0;
}

.card-image img {
  height: 150px;
  width: auto;
  margin: auto;
}

a.remove {
  position: absolute;
  top: 10px;
  right: 10px;
}

.wrapper-outer {
  position: relative;
  width: 100%;
  padding-bottom: 100%;
}

.wrapper-inner {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  text-align: center;
}

.wrapper-inner img {
  height: 100%;
  display: inline-block;
}
#productName {
  font-size: 28px !important;
}
#drink-image .img {
  width: 230px;
  height: auto;
  position: relative;
}
#drink-image .img i {
  position: absolute;
  right: 20px;
  top: 20px;
  color: #b03236;
  background: white;
  border-radius: 13px;
  padding: 5px;
  border: 1px solid #b03236;
}
#drink-image img {
  width: 220px;
  height: 230px;
  object-fit: contain;
}
.v-input__control>.v-input__slot>.v-text-field__slot>input[type=text], .v-input__control>.v-input__slot>.v-text-field__slot>input[type=number] {
    margin: 0!important;
}
</style>
<template lang="pug">
div
  .row
    .col.m12.l12
      v-text-field#productName.col.s12.title(
        label='Name',
        v-model='mutableProduct.name',
        hide-details='auto'
      )
      v-text-field.col.s12.m6.pt-3(
        label='Category',
        v-model='mutableProduct.category',
        hide-details='auto'
      )
      v-text-field.col.s12.m6.pt-3(
        label='Bottler',
        v-model='mutableProduct.bottler',
        hide-details='auto'
      )
      v-text-field.col.s12.m6.pt-3(
        label='Country',
        v-model='mutableProduct.country',
        hide-details='auto'
      )
      v-text-field.col.s12.m6.pt-3(
        label='Region',
        v-model='mutableProduct.region',
        hide-details='auto'
      )
      .col.s12.m6.pt-4
        label(for='productTag') Tag
        .input-field
          select#productTag.browser-default(v-model='mutableProduct.tags')
            option conventional
            option The Scotch Malt Whisky Society
  .row
    .row(
      v-for='(variant, index) in mutableProduct.variants',
      v-bind:variant='variant',
      v-bind:id='variant.variantCode'
    )
      #drink-image.col.m2.l3.s12.no-padding
        div
          .img
            img(
              :src='variant.photo',
              :id='"var-" + index',
              @click='choose(index)'
            )
            i.material-icons(@click='choose(index)') edit
            input#products-photos.d-none(
              type='file',
              ref='filesinput',
              @change='setPhotos($event, variant, index)',
              accept='.png, .jpg, .jpeg'
            )
            label File names should exactly match to {{ variant.variantCode }}
      .col.m10.l9.s12
        h2.col.s12.title.medium.pt-4 {{ variant.variantCode }}
        .vspace.medium.col.s12
        v-text-field.col.s12.m6.pt-3(
          label='Age (years)',
          type='number',
          v-model='variant.age',
          hide-details='auto'
        )
        v-text-field.col.s12.m6.pt-3(
          label='Price',
          type='number',
          v-model='variant.price',
          hide-details='auto'
        )
        v-text-field.col.s12.m6.pt-3(
          label=' Volume (cl)',
          type='number',
          v-model='variant.volumeCl',
          hide-details='auto'
        )
        v-text-field.col.s12.m6.pt-3(
          label='Alcohol Content',
          type='number',
          v-model='variant.alcoholContent',
          hide-details='auto'
        )

    .col.s12.right-align.pt-5
      a.btn.btn-primary(@click='saveProduct()') Save
</template>
<script>
// import defaultPhoto from '../assets/default-no_prev.png'

export default {
  props: ['product', 'index', 'removable', 'onNewPSuccess', 'onNewPFailed'],
  data () {
    return {
      activeTab: this.product.variants
        ? this.product.variants[0].variantCode
        : null,
      mutableProduct: {
        name: this.product.name,
        productCode: this.product.productCode,
        category: this.product.category,
        bottler: this.product.bottler,
        country: this.product.country,
        region: this.product.region,
        variants: this.product.variants,
        tags: this.product.tags
      },
      photos: [],
      uploadMessage: null,
      uploadPercent: 0,
      uploading: false
    }
  },
  computed: {
    supplier () {
      return this.$store.state.profile.supplier
    }
  },
  mounted () {
    this.$M.updateTextFields()
    this.$M.Tabs.init(this.$refs.tabs)
    // if (typeof this.product.photo === 'object') {
    //   const fileReader = new FileReader()
    //   fileReader.onload = this.photoLoaded
    //   fileReader.readAsDataURL(this.product.photo)
    // } else if (typeof this.product.photo === 'string') {
    //   this.$refs.photo.src = this.product.photo
    // } else {
    //   this.$refs.photo.src = defaultPhoto
    // }
  },
  methods: {
    choose (i) {
      this.$refs.filesinput[i].click()
    },
    setPhotos (e, variant, i) {
      const photos = {}
      this.photos = null

      let isValid = null
      Array.from(e.target.files).forEach((photo) => {
        const variantCode = photo.name.replace(/\.[^/.]+$/, '')
        isValid = variant.variantCode === variantCode
        if (isValid) {
          photos[variantCode] = photo
          variant.photo = URL.createObjectURL(photo)
        }
      })
      this.photos = photos
    },
    removeProduct (e) {
      e.preventDefault()
      this.$emit('removeProduct', this.product.productCode, this.index)
    },
    photoLoaded (e) {
      this.$refs.photo.src = e.target.result
    },
    updateProducts () {
      const batchSize = 20
      const productKeys = Object.keys(this.mutableProduct)
      const batchCount = Math.ceil(productKeys.length / batchSize)

      const batches = []
      for (let i = 0, len = batchCount; i < len; i++) {
        batches.push(
          this.saveProduct(
            productKeys.slice(i * batchSize, (i + 1) * batchSize)
          )
        )
      }
    },
    saveProduct (productKeys) {
      //   const products = []
      const products = [this.mutableProduct]
      const variants = {}
      let op = []
      let pro = this.mutableProduct.variants
      Object.keys(pro).forEach(function (key) {
        op.push(pro[key])
      })
      variants[this.mutableProduct.productCode] = op
      this.$store
        .dispatch('auth/getAccessToken')
        .then((accessToken) => {
          return this.$http
            .post(
              `${this.$config.API_URL}/suppliers/${this.supplier.code}/products`,
              {
                products: products,
                variants: variants
              },
              {
                headers: {
                  Authorization: `Bearer ${accessToken}`
                }
              }
            )
            .then((result) => {
              //   this.$snackbar.success('Products successfully added!')
              this.$store.dispatch('modal/close')
              this.onNewPSuccess(result.data)
            })
        })
        .catch((err) => {
          this.onNewPFailed(err)
        })
      this.uploadPhotos()
    },
    uploadPhotos () {
      this.uploadMessage = 'Uploading photos'
      this.uploadPercent = 0
      const photoKeys = Object.keys(this.photos || {})
      if (!photoKeys.length) {
        return
      }

      const uploads = photoKeys.map((key) => {
        const photo = this.photos[key]
        return this.uploadPhoto(photo)
      })

      return Promise.each(uploads, (res, index, len) => {
        this.uploadPercent = Math.ceil(((index + 1) / len) * 100)
      })
    },
    uploadPhoto (photo) {
      return this.$store.dispatch('auth/getAccessToken').then((accessToken) => {
        const data = new FormData()
        data.append('photos', photo)
        return this.$http.post(
          `${this.$config.API_URL}/suppliers/${this.supplier.code}/products/photos`,
          data,
          {
            headers: {
              Authorization: `Bearer ${accessToken}`,
              'Content-Type': 'multipart/form-data'
            }
          }
        )
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/app-product-details.vue